function updateShippingTimer() {
  const timerElement = document.querySelector('.product-info__shipping-info .timer');
  if (!timerElement) return;

  // Get current time in PST/PDT
  const now = new Date();
  const pstDate = new Date(now.toLocaleString('en-US', { timeZone: 'America/Los_Angeles' }));
  
  // Set target time to 5 PM PST/PDT today
  const targetDate = new Date(pstDate);
  targetDate.setHours(17, 0, 0, 0);
  
  // If current time is past 5 PM, set target to tomorrow at 5 PM
  if (pstDate > targetDate) {
    targetDate.setDate(targetDate.getDate() + 1);
  }
  
  // Calculate time difference
  const timeDiff = targetDate - pstDate;
  
  // Convert to hours, minutes, seconds
  const hours = Math.floor(timeDiff / (1000 * 60 * 60));
  const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);
  
  // Format time string
  const timeString = [
    hours.toString().padStart(2, '0'),
    minutes.toString().padStart(2, '0'),
    seconds.toString().padStart(2, '0')
  ].join(':');
  
  // Update timer display
  timerElement.textContent = timeString;
}

// Update timer every second
setInterval(updateShippingTimer, 1000);

// Initial update
updateShippingTimer();